import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../api-new/http";
import { appUrls } from "../../../api-new/urls";
import { FetchPriceBoardRequestAction, fetchPriceBoardSuccess } from "./actions";
import { FETCH_PRICE_BOARD_REQUEST } from "./constants";
import { SagaIterator } from "redux-saga";


export function* chartSaga(action: FetchPriceBoardRequestAction): SagaIterator {
    try {
        const data = yield call(() => api.get(`${appUrls.stockURL}/symbol/price-board/${action.payload}`));
        if (data) {
            yield put(fetchPriceBoardSuccess(data.data[0]));
        }
    } catch (error) {
        // yield put(
        //     sendError({
        //         error,
        //         processingType: 'alert',
        //         extraOptions: {
        //             actionError: fetchTickersGroupFailure,
        //         },
        //     })
        // );
    }
}

export function* rootPriceBoardSaga(): Generator {
    yield takeLatest(FETCH_PRICE_BOARD_REQUEST, chartSaga);
}
